import React from 'react';

const SalesDocsTab = ({ isCollapsed }) => {
    // Демо-данные (без бэка)
    const docs = [
        {
            id: 1,
            number: '2605004',
            date: '21.05.2025',
            amount: '765 000,56',
            client: 'ВЕРХ-ИСЕТСКАЯ ТОРГОВАЯ КОРПОРАЦИЯ',
            manager: 'Петр Иванов',
        },
        {
            id: 2,
            number: '2606018',
            date: '11.06.2025',
            amount: '598 904,60',
            client: 'ПЛАСТЭК-ТЕХНИК ООО',
            manager: 'Николай Расторгуев',
        },
    ];

    const renderRow = (doc, index) => (
        <div key={doc.id || index} className="clients-table__row">
            <div className="clients-table__cell clients-table__cell--id">{doc.number || '—'}</div>
            <div className="clients-table__cell">{doc.date || '—'}</div>
            <div className="clients-table__cell">{doc.amount || '—'}</div>
            <div className="clients-table__cell">{doc.client || '—'}</div>
            <div className="clients-table__cell">{doc.manager || '—'}</div>
        </div>
    );

    return (
        <section className={`page-content ${isCollapsed === null ? '' : isCollapsed ? 'page-content_collapsed' : 'page-content_full-width'}`}>
            <article className="users">
                <div className="clients-toolbar">
                    <div className="clients-toolbar__search">
                        <input type="text" placeholder="Поиск ...." />
                        <svg className="clients-toolbar__search-icon" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.7938 14.6615C14.6355 14.6615 17.7498 11.5473 17.7498 7.70574C17.7498 3.86419 14.6355 0.75 10.7938 0.75C6.95218 0.75 3.83789 3.86419 3.83789 7.70574C3.83789 11.5473 6.95218 14.6615 10.7938 14.6615Z" stroke="#1C1C1C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M5.87594 12.6245L0.75 17.7503" stroke="#1C1C1C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div className="clients-table clients-table--docs">
                    <div className="clients-table__header">
                        <div className="clients-table__row">
                            <div className="clients-table__cell clients-table__cell--id">УПД (фактура)</div>
                            <div className="clients-table__cell">Дата</div>
                            <div className="clients-table__cell">Сумма</div>
                            <div className="clients-table__cell">Клиент</div>
                            <div className="clients-table__cell">Менеджер</div>
                        </div>
                    </div>
                    <div className="clients-table__body">
                        {docs.length === 0 ? (
                            <div className="clients-table__row">
                                <div className="clients-table__cell" style={{ gridColumn: '1 / -1' }}>
                                    Документы не найдены
                                </div>
                            </div>
                        ) : (
                            docs.map(renderRow)
                        )}
                    </div>
                </div>
            </article>
        </section>
    );
};

export default SalesDocsTab;
